<script setup lang="ts">
import type {
  NovaCalendarControlPanelEmits,
  NovaCalendarControlPanelProps,
} from './NovaCalendarControlPanel.types'

const emit = defineEmits<NovaCalendarControlPanelEmits>()
withDefaults(defineProps<NovaCalendarControlPanelProps>(), {
  activeIndex: -1,
})

const onClickControl = (index: number) => {
  emit('onClickControl', index)
}
</script>

<template>
  <div class="calendar-control-panel grid-wrapper grid-3 gap-12">
    <NovaCalendarControlButton
      v-for="item in controls"
      :key="item.index"
      :label="item.value"
      :compact="true"
      :on="item.index === activeIndex"
      :disabled="item.disabled"
      @click="() => onClickControl(item.index)"
    />
  </div>
</template>

<style lang="scss" scoped>
.calendar-control-panel {
  padding: 12px;
  background-color: $color-white;
  box-shadow: 0 12px 12px 0 hex-to-rgba($color-black, 0.2);
  border-radius: 12px;
  height: 100%;
  max-height: 264px;
  overflow-x: hidden;
  overflow-y: overlay;
}
</style>
